import { Api } from './lib/Api';

/**
 * Api
 */
export default new Api();